module.exports = (__webpack_require__(66442))(3336);